<template>
    <div class="md-layout-item md-elevation-0"> 

        <md-card class="md-elevation-1 m-5">

          <md-card-header v-if="title == 'Titular'" class="md-layout md-alignment-center-left justify header-bg">
          Información de Partícipe 
          </md-card-header> 
          <md-card-header v-else class="md-layout md-alignment-center-left justify header-bg">
          Información del Mancomuno 
          </md-card-header>           

          <md-card-content>
            <div>
                <p align="justify">
                    Bienvenido al proceso de suscripción inicial de los fondos mutuos de Faro Capital. Agradeceremos completar toda la información solicitada. ¡Muchas gracias!
                </p>
                
            </div>
            <div>
                <img src="@/assets/faro.png"/>
            </div>
              
          </md-card-content>

        </md-card>

        <div class="md-alignment-center-left justify">
          <md-button class="md-raised" @click="Next">Siguiente</md-button>  
        </div>        

    </div>
</template>

<script>
export default {
    name:"Item000",
    props:["title", "data"],
    data: () => ({
        form:{
        }
    }),    
    mounted:function(){

    },
    methods:{
        Next(){
            var x = "0"
            if(this.data.name == "Participe"){
                x = "1"
            }
            this.$emit('setDone', {id: "000", index: x})
        }
    }
}
</script>

<style>

</style>